'use client';

import { ReactNode } from 'react';

type DisabledReasonTooltipProps = {
    reason?: string | null;
    children: ReactNode;
    className?: string;
};

const DisabledReasonTooltip = ({ reason, children, className = 'w-full' }: DisabledReasonTooltipProps) => {
    if (!reason) {
        return <>{children}</>;
    }

    return (
        <span className={`group relative inline-flex ${className}`} title={reason}>
            {children}
            <span
                role="tooltip"
                className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 hidden max-w-64 -translate-x-1/2 rounded-md bg-slate-900 px-3 py-2 text-xs leading-4 text-white shadow-lg group-hover:block group-focus-within:block"
            >
                {reason}
            </span>
        </span>
    );
};

export default DisabledReasonTooltip;
